import type React from "react";
import type { ReactNode } from "react";

import { useReactTooltip } from "hooks/useReactTooltip";
import { ParagraphSmall } from "styles/elements/Texts";
import { StyledBox } from "./ProgressStatBox.styled";

interface ProgressStatBoxProps {
  dataCy?: string;
  title: string;
  tooltip?: string;
  startIcon?: ReactNode;
  value: ReactNode; // Value is expected to be a node of these types: CssFlex, Heading3
}

export const ProgressStatBox: React.FC<ProgressStatBoxProps> = ({
  dataCy,
  title,
  tooltip,
  value,
  startIcon,
}) => {
  useReactTooltip(!!tooltip);
  return (
    <StyledBox data-cy={dataCy}>
      {startIcon}
      <div>
        <ParagraphSmall>{title}</ParagraphSmall>
        {value}
      </div>
    </StyledBox>
  );
};
